import React, { useEffect, useState, useRef } from "react";
import { classNames } from "../../helpers/classNames";

const Input = ({
  label,
  labelClasses,
  inputType = "text",
  inputClasses,
  inputPlaceholder,
  inputValue,
  inputName,
  errorType,
  errorText,
  isDisabled,
  value,
  required,
  iconClasses,
  maxLength,
  inputSuffix,
  inputPrefix,
  onChange = () => {},
  onKeyDown = () => {},
  ...props
}) => {
  const [passwordVisibility, setPasswordVisibility] = useState(false);
  const passwordInput = useRef(null);
  const handleClick = () => {
    setPasswordVisibility(!passwordVisibility);
  };

  useEffect(() => {
    passwordInput.current.type = passwordVisibility ? "text" : inputType;
  }, [passwordVisibility]);

  return (
    <div className="w-full relative">
      {label && (
        <div
          className={
            "text-sm font-medium text-text-disabled mb-1  " +
            labelClasses
          }
        >
          {label}
          {required && (
            <span className="text-[8px] text-red-500 ml-1 absolute top-[-2px]">
              <i className="fa-solid fa-asterisk"></i>
            </span>
          )}
        </div>
      )}
      <div className="relative flex">
        {inputPrefix && (
          <div
            className={classNames(
              "h-full aspect-square absolute top-2 left-1 bg-transparent text-slate-500",
              iconClasses
            )}
          >
            {inputPrefix}
          </div>
        )}
        {isDisabled ? (
          <input
            type={inputType}
            ref={passwordInput}
            className={classNames(
              "w-full h-10 rounded-md placeholder:text-text-disabled border border-text-secondary/50 px-3  text-sm text-sidebar !ring-0 !outline-0 focus:border-text-disabled transition-all duration-200 cursor-not-allowed bg-slate-50/80 opacity-65",
              inputClasses
            )}
            placeholder={inputPlaceholder}
            name={inputName}
            defaultValue={inputValue || 0}
            autoComplete={"new-" + inputType}
            value={value}
            disabled
          />
        ) : (
          <input
            type={inputType}
            ref={passwordInput}
            className={
              "w-full h-10 rounded-md placeholder:text-text-disabled bg-white border border-text-secondary/50 px-3  text-sm text-sidebar !ring-0 !outline-0 focus:border-text-disabled transition-all duration-200 " +
              inputClasses
            }
            value={value}
            maxLength={maxLength}
            placeholder={inputPlaceholder}
            name={inputName}
            defaultValue={inputValue}
            autoComplete={"new-" + inputType}
            onChange={(e) => onChange(e)}
            onKeyDown={onKeyDown}
          />
        )}
        {inputSuffix && (
          <div
            className={classNames(
              "h-full aspect-square absolute top-2 right-0 bg-transparent text-slate-500",
              iconClasses
            )}
          >
            {inputSuffix}
          </div>
        )}
        {inputType === "password" && (
          <button
            type="button"
            className={classNames(
              "h-full aspect-square absolute top-0 right-0 bg-transparent text-slate-500",
              iconClasses
            )}
            onClick={handleClick}
          >
            <i
              className={
                "fa-regular fa-fw text-slate-500 " +
                (passwordVisibility ? "fa-eye-slash" : "fa-eye")
              }
            ></i>
          </button>
        )}
      </div>
      {errorType && errorType === "error" && (
        <div className="text-xs text-red-600 mt-1">
          <i className="fa-regular fa-fw fa-square-exclamation text-sm mr-1"></i>
          {errorText}
        </div>
      )}
      {errorType && errorType === "warning" && (
        <div className="text-xs text-amber-600 mt-1">
          <i className="fa-regular fa-fw fa-triangle-exclamation text-sm mr-1"></i>
          {errorText}
        </div>
      )}
      {errorType && errorType === "success" && (
        <div className="text-xs text-green-600 mt-1">
          <i className="fa-regular fa-fw fa-circle-check text-sm mr-1"></i>
          {errorText}
        </div>
      )}
      {errorType && errorType === "info" && (
        <div className="text-xs text-sky-600 mt-1">
          <i className="fa-regular fa-fw fa-circle-info text-sm mr-1"></i>
          {errorText}
        </div>
      )}
    </div>
  );
};

export default Input;
